import { createStore} from 'vuex';

import merchant from './modules/merchant';
import message from './modules/message';
import statistic from './modules/statistic';
import store from './modules/store';
import miniapp from './modules/miniapp';
import system from './modules/system';
import device from './modules/device'

const storeIndex = createStore({
  modules: {
    merchant,
    message,
    statistic,
    store,
    miniapp,
    system,
    device,
  },
  state: {},
  mutations: {},
  actions: {},
})

export default storeIndex;
